export const buildListColumns = (fields, options, schema) => {
  return fields.map((field, index) =>
    Object.assign({
      key: index,
      dataField: field,
      dataLabel: schema[field].label,
      headerAlign: schema[field].type === Number ? 'right' : 'left',
      dataAlign: schema[field].type === Number ? 'right' : 'left',
      buildCell: value => value,
      buildTooltip: value => null
    }, options[field])
  )
}



// WEBPACK FOOTER //
// ./src/lib/generator.js